import React, {useEffect, useState} from 'react';

const Calendar = ({selectedDate, onDateSelect, timeSlots}) => {
    const today = new Date();
    const [currentMonth, setCurrentMonth] = useState(new Date(today.getFullYear(), today.getMonth(), 1));
    const [unavailableDates, setUnavailableDates] = useState([]);

    const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

    const generateCalendar = () => {
        const month = currentMonth.getMonth();
        const year = currentMonth.getFullYear();
        const daysInMonth = getDaysInMonth(month, year);
        const firstDay = new Date(year, month, 1).getDay();
        const days = [];

        for (let i = 0; i < firstDay; i++) days.push(null);
        for (let d = 1; d <= daysInMonth; d++) days.push(new Date(year, month, d));

        return days;
    };

    const getWorkHoursForDate = (date) => {
        const day = date.getDay();
        switch (day) {
            case 0:
                return timeSlots.sundayWorkHours;
            case 6:
                return timeSlots.saturdayWorkHours;
            default:
                return timeSlots.weekdayWorkHours;
        }
    };

    useEffect(() => {
        const days = generateCalendar();
        const invalids = days.filter(date => {
            if (!date) return false;
            const isPast = date < new Date(today.toDateString());
            const workHours = getWorkHoursForDate(date);
            return isPast || !workHours;
        });
        setUnavailableDates(invalids.map(date => date?.toDateString()));
    }, [currentMonth, timeSlots]);

    const isSameDate = (a, b) =>
        a && b && a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();

    const isDisabled = (date) => unavailableDates.includes(date.toDateString());

    const handlePrevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
    };

    const handleResetToToday = () => {
        setCurrentMonth(new Date(today.getFullYear(), today.getMonth(), 1));
        onDateSelect(today);
    };

    const days = generateCalendar();

    return (
        <div className="transition-all duration-300">
            <div className="flex justify-between items-center mb-4">
                <button onClick={handlePrevMonth} className="text-sm text-blue-500 hover:underline">&lt; Prev</button>
                <div className="flex flex-col items-center">
          <span className="font-semibold">
            {currentMonth.toLocaleString('default', {month: 'long'})} {currentMonth.getFullYear()}
          </span>
                    <button
                        onClick={handleResetToToday}
                        className="text-xs text-blue-400 hover:underline mt-1"
                    >
                        Today
                    </button>
                </div>
                <button onClick={handleNextMonth} className="text-sm text-blue-500 hover:underline">Next &gt;</button>
            </div>

            <div className="grid grid-cols-7 gap-1 text-center text-sm font-semibold text-gray-600 mb-1">
                {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d) => <div key={d}>{d}</div>)}
            </div>

            <div className="grid grid-cols-7 gap-1 text-center text-sm font-medium">
                {days.map((day, i) =>
                    day ? (
                        <button
                            key={i}
                            onClick={() => !isDisabled(day) && onDateSelect(day)}
                            disabled={isDisabled(day)}
                            className={`p-1 rounded-md transition-all duration-150 ${
                                isDisabled(day)
                                    ? 'text-gray-300 bg-gray-100 cursor-not-allowed'
                                    : isSameDate(day, selectedDate)
                                        ? 'bg-blue-500 text-white'
                                        : 'hover:bg-blue-100'
                            }`}
                        >
                            {day.getDate()}
                        </button>
                    ) : (
                        <div key={i}></div>
                    )
                )}
            </div>
        </div>
    );
};

export default Calendar;
